import _ from 'lodash';
import type React from 'react';

export interface IPublishMixin<P = any, S = any> extends React.Mixin<P, S> {
  limits: {};
  get<K extends keyof P>(key: K, props?: P): P[K];
  bind<K extends keyof P>(
    key: K
  ): {
    value: P[K];
    requestChange(): void;
  };

  publish<K extends keyof P>(val: P[K], key: K): void;
}

const all: IPublishMixin = {
  limits: {},

  getInitialState: function () {
    return {};
  },

  getDefaultProps: function () {
    return { readOnly: false };
  },

  get: function (key, props) {
    props = props || this.props;
    let value = !!key ? key : 'value';

    return !!props[value + 'Link'] ? props[value + 'Link'].value : props[value];
  },

  bind: function (key) {
    let value = !!key ? key : 'value';

    return (
      this.props[value + 'Link'] || {
        value: this.props[value],
        requestChange: this.props[!!key ? key + 'OnChange' : 'onChange']
      }
    );
  },

  publish: function (val, key) {
    let value = !!key ? key : 'value';
    let onChange = !!key ? key + 'OnChange' : 'onChange';

    if (!!this.props[value + 'Link'] && this.props[value + 'Link'].requestChange) {
      this.props[value + 'Link'].requestChange(val);
      return;
    }

    if (!!this.props[onChange]) this.props[onChange](val);
  }
};

export default all;

export const { limits, getInitialState, getDefaultProps, get, bind, publish } = all;
